import Policy from './Policy'

// Backend policies resolved in: backend/components/surveys/app/presenters/surveys/v2/survey_presenter.rb
export type SurveysFormVerbTypes = 'editSurveysForm'

class SurveysFormPolicy extends Policy<SurveysFormVerbTypes> {
  checkVerb(verb: SurveysFormVerbTypes): boolean {
    switch (verb) {
      case 'editSurveysForm':
        return this.permissions.edit // FIXME: Double check this, because it looks like broken

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
      // TODO: DRY
    }
  }
}

export default SurveysFormPolicy
